"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, SkeletonBlock, SkeletonLine, TableCell, TableRow, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
import { COLLECTION_TRAIT_ITEMS_TABLE_COLUMN_CLASSNAMES } from "./styles";
export function CollectionTraitItemsTableSkeletonRow() {
  const $ = _c(26);
  const {
    size
  } = useTable();
  let T0;
  let T1;
  let T2;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    T2 = TableRow;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <TableCell className={COLLECTION_TRAIT_ITEMS_TABLE_COLUMN_CLASSNAMES.trait}><SkeletonLine className="w-1/2" /></TableCell>;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <TableCell className={COLLECTION_TRAIT_ITEMS_TABLE_COLUMN_CLASSNAMES.traitCount}><SkeletonLine className="w-1/2" /></TableCell>;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    T1 = TableCell;
    t2 = COLLECTION_TRAIT_ITEMS_TABLE_COLUMN_CLASSNAMES.items;
    T0 = FlexCenter;
    t0 = "gap-2";
    t1 = range(5).map(index => <SkeletonBlock className={image()} key={index} />);
    $[0] = size;
    $[1] = T0;
    $[2] = T1;
    $[3] = T2;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[1];
    T1 = $[2];
    T2 = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[11] !== T0 || $[12] !== t0 || $[13] !== t1) {
    t5 = <T0 className={t0}>{t1}</T0>;
    $[11] = T0;
    $[12] = t0;
    $[13] = t1;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== T1 || $[16] !== t2 || $[17] !== t5) {
    t6 = <T1 className={t2}>{t5}</T1>;
    $[15] = T1;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TableCell className={COLLECTION_TRAIT_ITEMS_TABLE_COLUMN_CLASSNAMES.traitFloor}><SkeletonLine className="w-1/2" /></TableCell>;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <TableCell className={COLLECTION_TRAIT_ITEMS_TABLE_COLUMN_CLASSNAMES.bestOffer}><SkeletonLine className="w-1/2" /></TableCell>;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== T2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t6) {
    t9 = <T2>{t3}{t4}{t6}{t7}{t8}</T2>;
    $[21] = T2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t6;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}